// Sugestões do thread vazio (SZ-1595, B.7 do plano chat-first): 3 exemplos do
// que ESTE agente faz, derivados do job_title que já chega nas props do chat —
// nenhuma chamada de rede extra no mount. As props não expõem rotinas nem
// canais do worker, então o job_title (catálogo JOB_TITLES do DigitalWorker) é
// a fonte mais específica disponível. Clicar pré-preenche o composer, não envia.
const SUGGESTIONS_BY_JOB_TITLE: Record<string, readonly string[]> = {
  'Analista de Marketing': [
    'Como estão as campanhas ativas hoje?',
    'Prepare um relatório de desempenho da última semana.',
    'Qual anúncio teve o melhor resultado ontem?',
  ],
  'Analista de Operações': [
    'Como estão os processos em andamento?',
    'Há alguma pendência precisando da minha atenção?',
    'Resuma o que você fez hoje.',
  ],
  'Assistente Generalista': [
    'Pesquise um assunto e traga um resumo.',
    'Monte uma planilha para organizar uma tarefa.',
    'Crie uma rotina recorrente para mim.',
  ],
  'Customer Success': [
    'Como está a fila de atendimento agora?',
    'Resuma as conversas de hoje.',
    'Há algum cliente esperando resposta?',
  ],
  'Data Engineer': [
    'Quais fontes de dados deste projeto ainda têm lacunas?',
    'Verifique a qualidade e a atualização dos ativos de dados.',
    'Quais dados já podem ser ligados aos processos mapeados?',
  ],
}

// Fallback sóbrio para job_title ausente ou fora do catálogo, alinhado às
// sugestões genéricas da home (SZ-1578).
const DEFAULT_SUGGESTIONS: readonly string[] = [
  'O que você pode fazer por mim?',
  'O que precisa da minha atenção hoje?',
  'No que você está trabalhando agora?',
]

export function threadSuggestionsFor(jobTitle: string | null): readonly string[] {
  if (!jobTitle) return DEFAULT_SUGGESTIONS

  return SUGGESTIONS_BY_JOB_TITLE[jobTitle] ?? DEFAULT_SUGGESTIONS
}
